<template>
    <div class="vacancy-contacts" v-if="vacancyPage != null">
        <!-- {{vacancyContacts}} -->
        <div class="item" v-for="item in vacancyContacts">
            <div class="title">
                <h3>{{item.name}}</h3>
            </div>
            <div class="phones">
                <svgIcon name="mobile" class="icon-mobile"/>
                <ul>
                    <li v-for="elem in item.contacts">
                        <a :href="'tel:' + elem.phone">{{elem.phone}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'vacancy-contacts',
        components: {
            svgIcon,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
            }
        },
        computed: mapGetters({
            vacancyPage: 'loadVacancyPage',
            vacancyContacts: 'loadVacancyContacts',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // this.buildFiterCity();
            // // this.initFilterCityByPageLoad();
            // this.$store.watch(
            //     (state) => state.projectItemsFilter,
            //     (newValue) => {
            //         this.buildFiterCity();
            //         // this.initFilterCityByPageLoad();
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/vacancy-page/vacancy-contacts.scss';
    @import '@/styles/components/vacancy-page/respond/vacancy-contacts-respond.scss';
    // @import '@/styles/respond/vacancy/vacancy-contacts-respond.scss';
</style>